import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service'
import { RouterModule, Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  theme:string = "";
  errMsg:string = "";
  okMsg:string = "";
  tipoPwd:string = "password";
  tiempoMsg:number = 2100;
  resultado:any;
  usuario:any;
  grls:any;
  mail:any;
  sysN:string="";
  isAlive:any;
  infoWeb:any;
  ver:any; 


  constructor(private dataService: DataService, private router:Router) {
    this.sysN = this.dataService.sN;
    this.tiempoMsg = this.dataService.sTerr;
    this.dataService.infoApp();
    this.dataService.infoWebClient();
    this.dataService.getG().subscribe(
                          rows => {   
                                  this.grls = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnGrlsCargados());  
    this.dataService.getMail('1').subscribe(
                          rows => {   
                                  this.mail = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnMailCargado());  
  }

  ngOnInit() {
    this.fnRevisaBD();
    this.dataService.sysVer().subscribe(
                          rows => {   
                                  this.ver = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnSysVer()); 
  }

  fnSysVer(){
    //console.log(this.ver)
    if(this.dataService.infoVer().substr(0,5) != this.ver.res.substr(0,5)){
      console.log("VERSION FRONT(" + this.dataService.infoVer() + ") NO CORRESPONDE CON VERSIÓN BACK (" + this.ver.res + ")!")
    }
  }

  fnRevisaBD(){
      //console.log("Alive?");
      this.dataService.isAlive().subscribe(
                        rows => {   
                                this.isAlive = rows
                                },          
                        error => this.fnSinConexion(error),
                        () => this.fnOk() );      
  }

  fnSinConexion(err){
    console.log(err);
    this.errMsg = "« ERROR: Sin conexión a base de datos! »"
    setTimeout(() => {
       this.ngOnInit(); 
       //console.log("Revisando BD!")
    },10000); 
    
  }

  fnOk(){
    //console.log(this.isAlive[0]);
    try{
      if(this.isAlive[0].vivo){
        this.errMsg="";
        //console.log("Conexión exitosa con BD");
      }
    }
    catch(err){
      console.log(err);
      this.errMsg = "« ERROR: Sin conexión a base de datos! »"
    }
  }
   
  fnMailCargado(){
    //console.log(this.mail);
  }

  fnGrlsCargados(){
    //console.log (this.grls);
    if(this.grls){
      if(this.grls[0]){
        if(this.grls[0].n){
          this.dataService.sN = this.grls[0].n;
          this.sysN = this.grls[0].n;
        }
        if(this.grls[0].we)
          this.dataService.sWe = this.grls[0].we;
        if(this.grls[0].m)
          this.dataService.sM = this.grls[0].m;
        if(this.grls[0].t1)
          this.dataService.sT1 = this.grls[0].t1;
        if(this.grls[0].t2)
          this.dataService.sT2 = this.grls[0].t2;
        if(this.grls[0].wa)
          this.dataService.sWa = this.grls[0].wa;
        if(this.grls[0].de)
          this.dataService.sDe = this.grls[0].de;
        if(this.grls[0].di)
          this.dataService.sDi = this.grls[0].di;
        if(this.grls[0].di2)
          this.dataService.sDi2 = this.grls[0].di2;
        if(this.grls[0].terr){
          this.dataService.sTerr = this.grls[0].terr;
          this.tiempoMsg = this.grls[0].terr;
        }
        if(this.grls[0].ip)
          this.dataService.sIP = this.grls[0].ip;
        if(this.grls[0].rfc)
          this.dataService.sRFC = this.grls[0].rfc;
        if(this.grls[0].cp)
          this.dataService.sCP = this.grls[0].cp;

      }
    }
  }

  fnRevelaPassword(txtElement){
    //console.log(txtElement.value);
    this.tipoPwd = "";
  }

  fnTapaPassword(){
    this.tipoPwd = "password";
  }

  fnKeyPress(t, ev){
    //console.log(ev)
    this.errMsg="";
    if (!this.dataService.validKey(t, ev)){
        this.errMsg="Caracter inválido!";
        setTimeout(() => {
            this.errMsg="";
        }, this.tiempoMsg);
        return false;
    }
    else{    
      if(ev.key=="Enter"){
        var u = <HTMLInputElement>document.getElementById("txtUsr");
        var p = <HTMLInputElement>document.getElementById("txtPwd");
        this.fnValidarLogin(u.value, p.value);
      }
      return true;
    }
  }

  fnValidarLogin(u,p){
    //console.log(u);
    //console.log(u);
    //console.log(p);
    if(u.indexOf('"')>=0 || u.indexOf("'")>=0 || p.indexOf('"')>=0 || p.indexOf("'")>=0){
      this.errMsg = "Intento de inyección SQL!";
      this.dataService.insLog('LOGIN','SQL INJECT', "[user]=" + u + ", [pwd]=" + p, this.errMsg).subscribe(
              row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
      setTimeout(() => {
        this.errMsg = "";
      }, this.tiempoMsg);
      return;
    }

    if (u.length < 1){
      this.errMsg = "Usuario inválido!"
      setTimeout(() => {
        this.errMsg = "";
      }, this.tiempoMsg);
      return;
    }
    if (p.length < 1){
      this.errMsg = "Contraseña inválida!"
      setTimeout(() => {
        this.errMsg = "";
      }, this.tiempoMsg);
      return;
    }
    var auxP = CryptoJS.MD5(p).toString();
    if(p.indexOf("#") == 0)
      auxP = p;
    this.dataService.getLogin(u, auxP).subscribe(
                          rows => {   
                                  this.resultado = rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnLoginResult(u, p));  
  }

  fnLoginResult(u, p){
    //console.log(this.resultado);
    if(this.resultado){
      var aux = JSON.stringify(this.resultado[0]);
      //console.log(aux);
      if(!aux){
        this.errMsg="Usuario y/o contraseña erroneos!";
        this.dataService.insLog('LOGIN','LOGIN', u, this.errMsg).subscribe(
                        row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
  
        setTimeout(() => {
          this.errMsg =""
        }, this.tiempoMsg); 
        return;       
      }
      if(aux.substring(0,12).indexOf("null") > 0){
        this.errMsg="Usuario y/o contraseña erroneos!";
        this.dataService.insLog('LOGIN','LOGIN', u, this.errMsg).subscribe(
                        row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
        setTimeout(() => {
          this.errMsg =""
        }, this.tiempoMsg);
        return;
      }
      this.usuario = this.resultado[0];
      console.log(this.usuario)
      
      //--> VALIDAR INICIOS DE SESIÓN EN OTRAS IPs
      //-->** PENDIENTE **<--  buscar si tiene conexiones activas, de ser asi, revisar la IP de éstas (podria tener en su equipo varias pestañas abiertas), si es una IP diferente, mostrar aviso de multiples sesiones
      var fecId = Date.now();
      this.okMsg = "Bienvenido: " + this.usuario.n;

      if(this.usuario.xcep == null){
        alert("Imposible continuar!\n\nEl rol del usuario no ha sido validado.\n\nPongase en contacto con el área de sistemas.");
        return;
      }
      
      sessionStorage.setItem('csiBILLlog', fecId.toString());
      sessionStorage.setItem('csiBILLusr', this.usuario.idu);
      sessionStorage.setItem('csiBILLusrN', this.usuario.n);
      sessionStorage.setItem('csiBILLusrR', this.usuario.idr.toString());
      sessionStorage.setItem('csiBILLusrM', this.usuario.m);
      sessionStorage.setItem('csiBILLusrX', this.usuario.xcep);
      sessionStorage.setItem('csiBILLusrFAP', this.usuario.fp);

      if(this.mail){
        if(this.mail[0]){
          sessionStorage.setItem('csiMAILh', this.mail[0].h);
          sessionStorage.setItem('csiMAILp', this.mail[0].p);
          sessionStorage.setItem('csiMAILus', this.mail[0].us);
          sessionStorage.setItem('csiMAILpw', this.mail[0].pw);
          sessionStorage.setItem('csiMAILssl', this.mail[0].ssl);    
          sessionStorage.setItem('csiMAILtsl', this.mail[0].tsl);
        }
      }      

      this.dataService.insLog('LOGIN','LOGIN', 'OK:' + this.usuario.idu, this.dataService.infoVer()).subscribe(
                      row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          

      setTimeout(() => {
          //--> Si es Administrador ir a Administración
          if(this.usuario.idr==0)
            this.router.navigate(['home']);
          //--> Si es Usuario ir a Home
          else
            this.router.navigate(['home']);
            //--> Usando parametros de navegación:
            //this.router.navigate(['home','']);
      }, 1000);
    }
  }

  fnRecuperarPwd(u){
    this.router.navigate(['recupwd', u ]);
  }
}
